import { Role } from "../../../../mp-database"
import { StudyPlanTargets } from "../../../machines/studyPlan/types"
import { SubPagesEnum } from "./types"

export const PROGRAMS_WITH_STUDY_PLAN_V2 = ["EACT", "DSAT", "TSIA2", "CLT"]

export const OVERALL = "Overall"
export const BASE_PATH = "/reporting/teaching-tools/study-plan"

export const OVERALL_NAV = [
  { label: "Progress", value: SubPagesEnum.progress, icon: "bar-progress" },
  {
    label: "Global Study Plan Settings",
    value: SubPagesEnum.settings,
    icon: "gear"
  }
]

export const SUBJECT_NAV = [
  {
    label: "Progress by Content",
    value: SubPagesEnum.progressByContent,
    icon: "bar-progress"
  },
  {
    label: "Scores by Student",
    value: SubPagesEnum.progressByStudent,
    icon: "user"
  },
  {
    label: "Manage Study Plans",
    value: SubPagesEnum.manage,
    icon: "clipboard"
  }
]

export const OVERALL_NAV_VALUES = OVERALL_NAV.map(item => item.value)
export const SUBJECT_NAV_VALUES = SUBJECT_NAV.map(item => item.value)

export const STUDY_PLAN_V2_SUBPAGE_TARGET_MAP: Record<
  SubPagesEnum,
  StudyPlanTargets
> = {
  [SubPagesEnum.progress]: StudyPlanTargets.Progress,
  [SubPagesEnum.progressByContent]: StudyPlanTargets.ProgressByContent,
  [SubPagesEnum.manage]: StudyPlanTargets.ManageStudyPlans,
  [SubPagesEnum.settings]: StudyPlanTargets.Settings,
  [SubPagesEnum.teacherOverall]: StudyPlanTargets.TeacherOverall,
  [SubPagesEnum.progressByStudent]: StudyPlanTargets.ProgressByStudent
}

export const STUDY_PLAN_V2_TARGET_SUBPAGE_MAP: Partial<
  Record<StudyPlanTargets, SubPagesEnum>
> = {
  [StudyPlanTargets.Progress]: SubPagesEnum.progress,
  [StudyPlanTargets.ProgressByContent]: SubPagesEnum.progressByContent,
  [StudyPlanTargets.ManageStudyPlans]: SubPagesEnum.manage,
  [StudyPlanTargets.TeacherView]: SubPagesEnum.manage,
  [StudyPlanTargets.Settings]: SubPagesEnum.settings,
  [StudyPlanTargets.TeacherOverall]: SubPagesEnum.teacherOverall,
  [StudyPlanTargets.ProgressByStudent]: SubPagesEnum.progressByStudent
}

export const STUDY_PLAN_V2_SUBJECT_TARGETS_BY_ROLE: Partial<
  Record<Role, StudyPlanTargets[]>
> = {
  "District Admin": [
    StudyPlanTargets.ProgressByContent,
    StudyPlanTargets.ProgressByStudent,
    StudyPlanTargets.ManageStudyPlans
  ],
  "School Admin": [
    StudyPlanTargets.ProgressByContent,
    StudyPlanTargets.ProgressByStudent,
    StudyPlanTargets.ManageStudyPlans
  ],
  Teacher: [
    StudyPlanTargets.ProgressByContent,
    StudyPlanTargets.ProgressByStudent,
    StudyPlanTargets.ManageStudyPlans
  ]
}

export const STUDY_PLAN_V2_OVERALL_TARGETS_BY_ROLE: Partial<
  Record<Role, StudyPlanTargets[]>
> = {
  "District Admin": [StudyPlanTargets.Progress, StudyPlanTargets.Settings],
  "School Admin": [StudyPlanTargets.Progress, StudyPlanTargets.Settings],
  Teacher: [StudyPlanTargets.Progress]
}

export const TARGET_HIDDEN_FILTERS: Partial<
  Record<StudyPlanTargets, string[]>
> = {
  [StudyPlanTargets.Progress]: ["student"],
  [StudyPlanTargets.Settings]: [
    "district",
    "school",
    "teacher",
    "grade",
    "class",
    "student"
  ]
}
